var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, select, take, takeEvery, takeLatest } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import { paymentPlanMap } from '../constants/payment';
import callApi from '../graphql/callApi';
import { PackageType, PaymentStatus, PlanStatus, } from '../graphql/generated/api';
import { getUserData } from '../selectors/user';
import { Plan } from '../type/pickups';
import sagaFactory from '../utils/sagaFactory';
export var getPackages = sagaFactory('getPackages', actions.getPackages, callApi.getPackages, 'packages', {
    delay: 300,
});
export var getConsolidationPackages = sagaFactory('getConsolidationPackages', actions.getConsolidationPackages, callApi.getPackages, 'packages', {
    delay: 300,
});
export var getPublicPackages = sagaFactory('getPackages', actions.getPublicPackages, callApi.getPublicPackages, 'packages', {
    delay: 300,
});
export var getPackagesByIdentifier = sagaFactory('getPackagesByIdentifier', actions.getPackagesByIdentifier, callApi.getPackagesByIdentifier, 'getPackagesByIdentifier', {
    delay: 300,
});
export var getPackage = sagaFactory('getPackage', actions.getPackage, callApi.getPackage, 'getPackage');
export var updatePackage = sagaFactory('updatePackage', actions.updatePackage, callApi.updatePackage, 'updatePackage');
export var getPackagesByCarrier = sagaFactory('getPackagesByCarrier', actions.getPackagesByCarrier, callApi.getPackagesByCarrier, 'packagesByCarrier');
export var getMissingPackages = sagaFactory('getMissingPackages', actions.getMissingPackages, callApi.getMissingPackages, 'missingPackages', {
    delay: 300,
});
export var createPackage = sagaFactory('createPackage', actions.createPackage, callApi.createPackage, 'createPackage');
export var clearPackageTrackingId = sagaFactory('clearPackageTrackingId', actions.clearPackageTrackingId, callApi.clearPackageTrackingId, 'clearPackageTrackingId');
export var deletePackage = sagaFactory('deletePackage', actions.deletePackage, callApi.deletePackage, 'deletePackage');
export var reschedule = sagaFactory('reschedule', actions.reschedule, callApi.reschedule, 'reschedule');
export var packageTrackingList = sagaFactory('packageTrackingList', actions.packageTrackingList, callApi.getPackageTrackingList, 'packageTrackingList');
export var packageTrackingListExpanded = sagaFactory('packageTrackingListExpanded', actions.packageTrackingListExpanded, callApi.getPackageTrackingListExpanded, 'packageTrackingList');
export var clearRequiresAgeVerification = sagaFactory('clearRequiresAgeVerification', actions.clearRequiresAgeVerification, callApi.clearRequiresAgeVerification, 'clearRequiresAgeVerification');
export var updateTripPackagesAddressId = sagaFactory('updateTripPackagesAddressId', actions.updateTripPackagesAddressId, callApi.updateTripPackagesAddressId, 'updateTripPackagesAddressId');
export var splitPackageByAddressId = sagaFactory('splitPackageByAddressId', actions.splitPackageByAddressId, callApi.splitPackageByAddressId, 'splitPackageByAddressId');
export function addNewPackage(_a) {
    var userData, shouldRefreshUser, res, resPackage, clientSecret, paymentIntent, makePaymentResp, err_1, message;
    var _b, _c, _d, _e, _f, _g;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                _h.trys.push([0, 19, , 21]);
                return [4 /*yield*/, select(getUserData)];
            case 1:
                userData = _h.sent();
                shouldRefreshUser = !(payload.paymentMethodId || ((_b = payload === null || payload === void 0 ? void 0 : payload.paymentMethod) === null || _b === void 0 ? void 0 : _b.id));
                if (paymentPlanMap[userData.paymentPlan] !== payload.plan) {
                    shouldRefreshUser = true;
                }
                return [4 /*yield*/, call(callApi.getTrip, {
                        id: payload.tripId,
                    })];
            case 2:
                res = _h.sent();
                return [4 /*yield*/, call(callApi.createPackage, {
                        input: {
                            tripId: payload.tripId,
                            labelType: payload.labelType,
                            status: payload.status,
                            labelUrl: payload.labelUrl,
                            description: payload.description,
                            carrierId: payload.carrierId,
                            retailerId: payload.retailerId,
                            trackingId: payload.trackingId,
                            isSwap: payload.isSwap,
                            paymentStatus: PaymentStatus.UNPAID,
                            source: payload.source,
                            createdBy: userData ? userData.id : null,
                            date: payload.date,
                            type: PackageType[((_d = (_c = res.data) === null || _c === void 0 ? void 0 : _c.trip) === null || _d === void 0 ? void 0 : _d.type) || PackageType.DROPOFF],
                        },
                    })];
            case 3:
                resPackage = _h.sent();
                if (!((_f = (_e = resPackage.data) === null || _e === void 0 ? void 0 : _e.createPackage) === null || _f === void 0 ? void 0 : _f.id)) return [3 /*break*/, 18];
                clientSecret = '';
                if (!(payload.plan === Plan.PER_PICKUP)) return [3 /*break*/, 9];
                if (!(payload.amount !== 0)) return [3 /*break*/, 8];
                return [4 /*yield*/, put({
                        type: actions.getPaymentIntent.type.REQUEST,
                        payload: {
                            amount: payload.amount,
                        },
                    })];
            case 4:
                _h.sent();
                return [4 /*yield*/, take([
                        actions.getPaymentIntent.type.SUCCESS,
                        actions.getPaymentIntent.type.FAILED,
                    ])];
            case 5:
                paymentIntent = _h.sent();
                if (!(paymentIntent.type === actions.getPaymentIntent.type.FAILED)) return [3 /*break*/, 7];
                return [4 /*yield*/, call(callApi.deletePackage, { id: resPackage.data.createPackage.id })];
            case 6:
                _h.sent();
                throw new Error(paymentIntent.payload);
            case 7:
                clientSecret = paymentIntent.payload.clientSecret;
                _h.label = 8;
            case 8: return [3 /*break*/, 10];
            case 9:
                if (userData.planStatus !== PlanStatus.ACTIVE) {
                    throw new Error('Something go wrong with payment');
                }
                _h.label = 10;
            case 10:
                if (!clientSecret) return [3 /*break*/, 14];
                return [4 /*yield*/, put({
                        type: actions.makePayment.type.REQUEST,
                        payload: {
                            cardElement: payload.cardElement,
                            clientSecret: clientSecret,
                            paymentMethodId: payload.paymentMethodId || ((_g = payload === null || payload === void 0 ? void 0 : payload.paymentMethod) === null || _g === void 0 ? void 0 : _g.id),
                        },
                    })];
            case 11:
                _h.sent();
                return [4 /*yield*/, take([
                        actions.makePayment.type.SUCCESS,
                        actions.makePayment.type.FAILED,
                    ])];
            case 12:
                makePaymentResp = _h.sent();
                if (!(makePaymentResp.type === actions.makePayment.type.FAILED)) return [3 /*break*/, 14];
                return [4 /*yield*/, call(callApi.deletePackage, { id: resPackage.data.createPackage.id })];
            case 13:
                _h.sent();
                throw new Error(makePaymentResp.payload);
            case 14: return [4 /*yield*/, put({
                    type: actions.addNewPackage.type.SUCCESS,
                    payload: resPackage.data.createPackage,
                })];
            case 15:
                _h.sent();
                next(true);
                if (!shouldRefreshUser) return [3 /*break*/, 17];
                return [4 /*yield*/, put({
                        type: actions.refresh.type.REQUEST,
                    })];
            case 16:
                _h.sent();
                _h.label = 17;
            case 17: return [2 /*return*/];
            case 18: return [3 /*break*/, 21];
            case 19:
                err_1 = _h.sent();
                message = err_1.message;
                console.error('addNewPackage', message);
                next(false, message || 'Something went wrong, try aging later');
                return [4 /*yield*/, put({
                        type: actions.addNewPackage.type.FAILED,
                    })];
            case 20:
                _h.sent();
                return [3 /*break*/, 21];
            case 21: return [2 /*return*/];
        }
    });
}
function packageSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actions.getPackagesByCarrier.type.REQUEST, getPackagesByCarrier)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getPackages.type.REQUEST, getPackages)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getConsolidationPackages.type.REQUEST, getConsolidationPackages)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updatePackage.type.REQUEST, updatePackage)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createPackage.type.REQUEST, createPackage)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.clearPackageTrackingId.type.REQUEST, clearPackageTrackingId)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.addNewPackage.type.REQUEST, addNewPackage)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deletePackage.type.REQUEST, deletePackage)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getMissingPackages.type.REQUEST, getMissingPackages)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPackage.type.REQUEST, getPackage)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPublicPackages.type.REQUEST, getPublicPackages)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPackagesByIdentifier.type.REQUEST, getPackagesByIdentifier)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.reschedule.type.REQUEST, reschedule)];
            case 13:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.packageTrackingList.type.REQUEST, packageTrackingList)];
            case 14:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.packageTrackingListExpanded.type.REQUEST, packageTrackingListExpanded)];
            case 15:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.clearRequiresAgeVerification.type.REQUEST, clearRequiresAgeVerification)];
            case 16:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updateTripPackagesAddressId.type.REQUEST, updateTripPackagesAddressId)];
            case 17:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.splitPackageByAddressId.type.REQUEST, splitPackageByAddressId)];
            case 18:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default packageSaga;
//# sourceMappingURL=package.js.map